/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ScratchDecl } from './ScratchDecl';

export type StoredEditorArtifact = {
    name: string;
    entry_point?: string;
    format: StoredEditorArtifact.format;
    width: number;
    height: number;
    passes?: (number | string);
    dispatch?: Array<'graph' | 'artifact'>;
    scratch?: Array<ScratchDecl>;
    shader_source: string;
};

export namespace StoredEditorArtifact {

    export enum format {
        R32FLOAT = 'r32float',
        RGBA8UNORM = 'rgba8unorm',
        RGBA16FLOAT = 'rgba16float',
        RGBA32FLOAT = 'rgba32float',
    }


}
